import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { MatDialog } from '@angular/material/dialog';
import { SqlEditorPopupComponent } from './sql-editor-popup/sql-editor-popup.component';
import { BaselineMappingViewPopupComponent } from './baseline-mapping-view-popup/baseline-mapping-view-popup.component';
import { CommonPopupSearchComponent } from '../common-popup-search/common-popup-search.component';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { EtlService } from '../vault-data-migration-etl/etl.service';
import { AttributeMappingPopupComponent } from './attribute-mapping-popup/attribute-mapping-popup.component';
import { Router } from '@angular/router';
import { VerifyMappingComponent } from 'src/app/user/attribute-mapping-config/verify-mapping/verify-mapping.component';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { constants } from 'src/app/shared/common/contants';
import { AttributeMappingConfigService } from 'src/app/shared/services/attribute-mapping-config.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { ActionwithcheckboxComponent } from 'src/app/shared/common/Actionwithcheckbox';
import { ActionCheckBox } from 'src/app/shared/common/ActionCheckBox'
import { ViewResultsComponent } from 'src/app/user/attribute-mapping-config/view-results/view-results.component'
import { UploadExcelFileComponent } from '../upload-excel-file/upload-excel-file.component';
import { VaultObjectRelationshipService } from 'src/app/shared/services/vault-object-relationship.service';
import {UserRoutingModule} from 'src/app/user/user-routing/user-routing.module';
import { FieldMappingService } from 'src/app/shared/services/field-mapping.service';
import { TextAreaComponent } from '../text-area/text-area.component';
import { FiledownloadComponent } from 'src/app/shared/common/filedownload.component';
import { RestApi } from "src/app/shared/RestApi/restApi";
import { JMigratorService } from "../jmigrator-tools/JMigrator.Service";
import { ImportJsonComponent } from 'src/app/shared/common/ImportJsonComponent ';


export interface AggregateDataBy {
  name: string,
  value: string
}



@Component({
    selector: 'app-attribute-mapping-config',
    templateUrl: './attribute-mapping-config.component.html',
    styleUrls: ['./attribute-mapping-config.component.scss'],
    standalone: false
})
export class AttributeMappingConfigComponent implements OnInit {

  @ViewChild('codeEditor') codeEditor!: ElementRef;
  @ViewChild('codeExceptionEditor') codeExceptionEditor!: ElementRef;
  @ViewChild('freetextEditor') freetextEditor!: ElementRef;
  expressionDetails: string = '';
  freetextDetails : string = '';
  exceptionExpressionDetails: string = '';
  

  db: any | null = null;
  validationMessage="";
  syntaxValidOrNot=true; 
navLinks = [ 
      {
        label: 'Objects',
        link: 'trnxBaseComponent?screenType=Dynamic%2FTransactions&tableName=objectmetadata&headerNameHtml=Objects',
        index: 0
      },
      {
        label: 'Stage Objects',
        link: 'stageobject',
        index: 1
      },
       {
        label: 'Objects Mapping',
        link: 'mappingconfiguration',
        index: 1
      },
      {
        label: 'Attributes Mapping',
        link: 'attributemappingconfig',
        index: 1
      },
      {
        label: 'Value Mapping',
        link: 'fieldMapping',
        index: 1
      },
      {
        label: 'Exception Queries',
        link: 'exceptionQueries',
        index: 1
      }
      
    ];
   validations_form: UntypedFormGroup;
   selectedObjects;
   mappingType;
   codelistValueType;
   codelistValueTypeQuery;
   codelistValueTypeConstant;
   selectedStageObjectForMappingType;
   selectedStageObjectAttributeForMappingType=null
   selectedStageObjectDetails
   query;
   codelistName;
   fieldOrderId;
   lookupMultiList=[]
  //  SOURCE VARIABLES
  columnDefsForSource;
  defaultColDef;
  rowSelectionForSource;
  sourceGrid;
  selectedSourceAttribute='';
  selectedSourceAttributeList=[];
  selectedSourceAttributeForExpression=''

  //  TARGET VARIABLES
  columnDefsForTarget;
  rowSelectionForTarget;
  targetGrid;
  selectedTargetAttribute='';
  selectedTargetAttributeList=[];
  selectedTargetAttributeForExpression=''

  expressionBuilderList=[]
  objectsList=[]

  aggregateExpressionList=[]

  selectedFunction='';
  groupByFunction='';
  conditionalValue=''

  backgroundColorScreen;
  buttonColor;
  mappingConfigurationData:any=[]
  mappedAttributesGrid;
  mappedAttributesColumnDefs;
  rowClassRules;
  components;
  componentsLookup;
  lastpage;
  currentpage;
  nextpage;
  nextpageplusone;
  totalpages;
  pagesize;
  paginationPageSize;
  paginationNumberFormatter;
  MappingAttributecheckbox: number[] = [];backgroundColorButton: (key: string) => string;
  uploadData: { csvContent: any[]; fileName: string; duplicates: boolean; attributes:boolean};
  excelData: any;
  name: any;
  tableName: any;
  sourceObjectsList: any;
  sql: any;
  selectedSourceAttributeForSQlConstruction: any;
  selectedTargetAttributeForSQlConstruction: any;
;
  insertObject:any = []
  ButtonApprove = "Approve"
  MappingAttributes = []
  isvisible = true
  gridAPIValidation
  RunlastPage1 
    RuncurrentPage1
    RunnextPage1 
    RunnextPagePlusOne1 
    RuntotalPages1 
    columnDefsExtractTemp
    value


  mappingAttributeDTO={
    source_attribute:[],
    target_attribute:'',
    target_attribute_list:[],
    mapping_type:'',
    mapping_logic:'',
    exceptionquery:'',
    mappingObjectId:'',
    mappingObject:'',
    source_object_id:"",
    target_object_id:"",
    source_object:'',
    target_object:'',
    tenantId:'',
    codelistname:'',
    fieldorderid:'',
    bussinesslogic:'',
    codelist_value_type:'',
    reference_source:'',
    reference_target:'',
    reference_library:'',
    reference_vault_object:'',
    reference_global_object:'',
    reference_global_source_library:'',
    global_external_object:'',
    lookupMappingDetails:'',
    reference_Database_Object_Name:"",
    reference_Database_Object_Fetch_Partial:""


  }


arrangeDataBy: AggregateDataBy[] = [
    { name: "Avg", value: "avg" },
    { name: "Count", value: "count" },
    //   { name: "Group Concate", value: "group_concat" },
    { name: "Max", value: "max" },
    { name: "Min", value: "min" },
    { name: "Sum", value: "sum" },
  ];
  
  mappingTypeData=[
    {
      label:"Direct Mapping",
      name:"Direct Mapping"
    },
    {
      label:"No Mapping",
      name:"No Mapping"
    },
    {
      label:"Functional Mapping",
      name:"Functional Mapping"
    },
    {
      label:"Codelist Mapping",
      name:"Codelist Mapping"
    },
    {
      label:"Lookup Mapping",
      name:"Lookup Mapping"
    },
    {
      label:"Concat Mapping",
      name:"Concat Mapping"
    }
  ]
  buttonName="Map";
  mappingAttributesId=0;
  validation_messages;
  buttonIdList = []
  isdisable: boolean = false;
  RunpageSize1

  selectedStageObject=[];
  SourceId
  stageObjectList:any=[]
  selectedStageObjectAttributesList:any=[]
  codeListData;
  ObjectsData;
  selectedReferenceSourceObjectsListNames
  selectedReferenceTargetObjectsListNames;
  selectedReferenceLibraryObjectsListNames;
  selectedReferenceGlobalObjectsListNames;
  selectedReferenceGlobalSourceObjectsListNames;
  selectedGlobalExternalObjectsListNames;
  selectedRefDBObjectNameListNames;
  selectedRefDBObjectNameFetchPartialsListNames;
  selectedReferenceValueMapping=[];
  selectedReferenceSourceObjectsList=[]
  selectedReferenceTargetObjectsList=[];
  selectedReferenceLibraryObjectsList=[];
  selectedReferenceGlobalObjectsList=[];
  selectedReferenceGlobalSourceObjectsList=[];
  selectedGlobalExternalObjectsList=[];
  selectedRefDBObjectNameFetchPartialsList=[];
  selectedRefDBObjectNameList=[];
  targetdnsid;
  referenceSourceObjectsList;
  referenceExternalObjectsList
  referenceTargetObjectsList;
  referenceLibraryObjectsLookupValue;
  referenceGlobalObjectsLookupValue;
  referenceSourceGlobalObjectsList;
  referenceLibraryObjectsList;
  referenceGlobalObjectsList;
  mappingTypeDataDropDown:any = [];
  defult:any = [];
  refresh_params
   targetAttributeDetails: any;
  SourceAttributesDetails: any;
  gridApi;
  lookupColumnDefs;
  lookupButtonName="Save";
  lookUpIndex;
  allObjectsList=[]
  valueMappingHeaders=[]
  codeListNameHeaders=[]
  codeListNamesDistinctData=[];
  selectedObjectMappingOrdeId;
  importExportTableName= "mappingattributes";
  constructor( private localStorageSettings: LocalStorageSettingsService,
    private constants: constants,private commonService:CommonService,
    private spinner: NgxUiLoaderService,private snackbar: MatSnackBar,
    private service: ReportingServiceService,
    private mappingAttributeServices:AttributeMappingConfigService,
    private msg: ErrorMessages,
    private validation: validationmethod,
    private dialog: MatDialog,
    private userRoutingModule: UserRoutingModule,
    private reportLinkService:ReportlinksserviceService,
    private linkservice: ReportlinksserviceService ,
    private etlservice:EtlService,
    private router: Router,
    private valueMappingservice:FieldMappingService,
    private vaultObjectRelationshipService: VaultObjectRelationshipService,
    private restApi: RestApi,
    private migratorService: JMigratorService,
    private etlEtlService: EtlService
    
  ) {
    this.validation_messages = this.msg.mappingAttributes;
      this.components = {
            buttonRenderer: ActionwithcheckboxComponent,
            downloadbuttonRenderer: FiledownloadComponent
          }
         this.componentsLookup= {
          buttonRenderer: Actionbutton
        }
     }
   
  ngOnInit(): void {


  
    let screenPath = this.userRoutingModule.print(this.constructor.name);
    console.log(screenPath);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });




    this.retrieveSourceAndTarget();

    this.columnDefsForSource= [
      {
        headerName: "Stage / Source Attributes",
        headerTooltip: "Source Attributes",
        tooltipValueGetter: params => "Source Attributes : " + params.value,
        field: "label",
        filter: "agTextColumnFilter",
        width: 520,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: false,
        sort:'asc',
        animateRows: true,
      }
    ];

    this.columnDefsForTarget= [
      {
        headerName: "Target Attributes",
        headerTooltip: "Target Attributes",
        tooltipValueGetter: params => "Target Attributes : " + params.value,
        field: "label",
        filter: "agTextColumnFilter",
        width: 520,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: false,
        sort:'asc',
        animateRows: true,
      }
    ];

    this.mappedAttributesColumnDefs = [{
      headerName: 'Action', filter: false, 
      cellRenderer: 'buttonRenderer',
      pinned:'left',
      lockPinned:true,
      value : this.MappingAttributecheckbox,
      cellRendererParams: {
         view: this.viewIcon.bind(this),
         values: this.buttonIdList,
        edit: this.EditIcon.bind(this),
        delete: this.deleteIcon.bind(this),
        onCheckboxChange:this.checkIcon.bind(this)
      }, width: 200
    },
      { headerName: 'Source Object', headerTooltip: 'Source Object', tooltipValueGetter: (params) => 'Source Object : ' + params.value, field: 'source_object', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Target Object', headerTooltip: 'Target Object', tooltipValueGetter: (params) => 'Target Object : ' + params.value, field: 'target_object', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Source Attributes', headerTooltip: 'Source Attributes', tooltipValueGetter: (params) =>{
        try {
            const parsed = JSON.parse(params.value);
            return 'Source Attributes : ' +parsed.map((item: any) => item.name).join(', ');
          } catch (e) {
            return 'Source Attributes : ' +''; // Fallback for invalid JSON
          }
      },
        field: 'source_attribute', 
         valueFormatter: params => {
         try {
            const parsed = JSON.parse(params.value);
            return parsed.map((item: any) => item.name).join(', ');
          } catch (e) {
            return ''; // Fallback for invalid JSON
          }
      },
        filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Target Attribute', headerTooltip: 'Target Attribute', tooltipValueGetter: (params) => 'Target Attribute : ' + params.value, field: 'target_attribute', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Mapping Type', headerTooltip: 'Mapping Type', tooltipValueGetter: (params) => 'Mapping Type : ' + params.value, field: 'mapping_type', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Codelist Name', headerTooltip: 'Codelist Name', tooltipValueGetter: (params) => 'Codelist Name : ' + params.value, field: 'codelistname', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Codelist Value Type', headerTooltip: 'Codelist Value Type', tooltipValueGetter: (params) => 'Codelist Value Type : ' + params.value, field: 'codelist_value_type', valueFormatter: params => {
    const value = params.value || '';
    return value.startsWith('Query:') ? value.replace(/^Query:/, '').trim() : value;
    }, filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Transformation Expressions', headerTooltip: 'Transformation Expressions', tooltipValueGetter: (params) => 'Transformation Expressions : ' + params.value, field: 'mapping_logic', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Exception Expressions', headerTooltip: 'Exception Expressions', tooltipValueGetter: (params) => 'Exception Expressions : ' + params.value, field: 'exceptionquery', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Bussiness Logic', headerTooltip: 'Bussiness Logic', tooltipValueGetter: (params) => 'Bussiness Logic : ' + params.value, field: 'bussinesslogic', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Status', headerTooltip: 'Status', tooltipValueGetter: (params) => 'Status : ' + params.value, field: 'status', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Created By', headerTooltip: 'Created By', tooltipValueGetter: (params) => 'Created By : ' + params.value, field: 'createdBy', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Created Date', headerTooltip: 'Created Date', tooltipValueGetter: (params) => 'Created Date : ' + params.value, field: 'createdDate', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Last Modified By', headerTooltip: 'Last Modified By', tooltipValueGetter: (params) => 'Last Modified By : ' + params.value, field: 'lastModifiedBy', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Last Modified Date', headerTooltip: 'Last Modified Date', tooltipValueGetter: (params) => 'Last Modified Date : ' + params.value, field: 'lastModifiedDate', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Approved Status', headerTooltip: 'Approved Status', tooltipValueGetter: (params) => 'ApprovedStatus : ' + params.value, field: 'approvedStatus', filter: 'agTextColumnFilter', width: 200 },
      { headerName: 'Approved Date', headerTooltip: 'Approved Date', tooltipValueGetter: (params) => 'ApprovedDate : ' + params.value, field: 'approvedDate', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Approved By', headerTooltip: 'Approved By', tooltipValueGetter: (params) => 'ApprovedBy : ' + params.value, field: 'approvedBy', filter: 'agTextColumnFilter', width: 250 }
      
    ]

     this.lookupColumnDefs = [{
      headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
       checkboxSelection: false,
      pinned:'left',
      lockPinned:true,
      cellRendererParams: {
        edit: this.EditLookupIcon.bind(this),
        delete: this.deleteLookUpIcon.bind(this),
      }, width: 150
    },
      { headerName: 'Selected Objects', headerTooltip: 'Selected Objects', tooltipValueGetter: (params) => 'Selected Objects : ' + params.value, field: 'selectedStageObjectForMappingType', filter: 'agTextColumnFilter'},
      { headerName: 'Selected Attributes', headerTooltip: 'Selected Attributes', tooltipValueGetter: (params) => 'Selected Attributes : ' + params.value, field: 'selectedStageObjectAttributeForMappingType', filter: 'agTextColumnFilter'},
      { headerName: 'Query', headerTooltip: 'Query', tooltipValueGetter: (params) => 'Query : ' + params.value, field: 'query', filter: 'agTextColumnFilter'},
    ],
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };
    this.rowSelectionForSource = "multiple";
    this.rowSelectionForTarget = this.constants.rowselection;
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
    this.formValidation();
    let dnsId = this.localStorageSettings.getSettings("dnsName");
     this.commonService.getlookupVauleByLookUpType("Mapping Type").subscribe(result => {
      console.log(result);
      this.mappingTypeDataDropDown = result;
      console.log(this.mappingTypeDataDropDown)

    });
    this.commonService.getlookupVauleByLookUpType("codelistValueType").subscribe(result => {
      console.log(result);
      this.defult = result;
      console.log(this.defult)

    });
    

    this.rowClassRules = {
      'rowBackgroundColor': function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };
    this.buttonColor=this.localStorageSettings.getSettings("ColorA")

    this.columnDefsExtractTemp = [
      { headerName: 'Execution Id', headerTooltip: 'Execution Id', tooltipValueGetter: (params) => 'Execution Id : ' + params.value, field: 'executionid', filter: 'agTextColumnFilter', width: 180 },
      { headerName: 'MappingTestBed Id', headerTooltip: 'MappingTestBed Id', tooltipValueGetter: (params) => 'mappingTestBedId : ' + params.value, field: 'testbedpath', filter: 'agTextColumnFilter', width: 180 },
      { headerName: 'Status', headerTooltip: 'Status', tooltipValueGetter: (params) => 'status : ' + params.value, field: 'status', filter: 'agTextColumnFilter', width: 180 },
      { headerName: 'Execution StartDate', headerTooltip: 'ExecutionStartDate', tooltipValueGetter: (params) => 'executionStartDate : ' + params.value, field: 'executionStartDate', filter: 'agTextColumnFilter', width: 180 },
      { headerName: 'Execution EndDate', headerTooltip: 'Execution EndDate', tooltipValueGetter: (params) => 'Execution EndDate : ' + params.value, field: 'executionEndDate', filter: 'agTextColumnFilter', width: 180 },
      { headerName: 'Verificationtype', headerTooltip: 'Verificationtype', tooltipValueGetter: (params) => 'verificationtype : ' + params.value, field: 'verificationtype', filter: 'agTextColumnFilter', width: 180 },
      { headerName: 'Download Log', headerTooltip: 'Download Log', filter: false, cellRenderer: 'downloadbuttonRenderer', cellRendererParams: { docdownload: this.downloadmappingfileExtract.bind(this),}, width: 180},

    ]

    this.paginationPageSize = 10;
  }
  formValidation() {
     this.validations_form = new UntypedFormGroup({
       objects: new UntypedFormControl("", [Validators.required]),
       expressionDetails:new UntypedFormControl(""),
       selectedSourceAttributeForExpression:new UntypedFormControl(""),
       selectedFunction:new UntypedFormControl(""),
       groupByFunction:new UntypedFormControl(""),
       conditionalValue:new UntypedFormControl(""),
       mappingType: new UntypedFormControl("", [Validators.required]),
       codelistname:new UntypedFormControl(""),
       selectStageObjectsForm:new UntypedFormControl(""),
       selectStageObjectsAttributesForm:new UntypedFormControl(""),
       codelistValueType:new UntypedFormControl(""),
       codelistValueTypeQuery:new UntypedFormControl(""),
       codelistValueTypeConstant:new UntypedFormControl(""),
       query:new UntypedFormControl(""),
       selectedReferenceSourceObjectsListNamesForm:new UntypedFormControl(""),
       selectedReferenceTargetObjectsListNamesForm:new UntypedFormControl(""), 
       selectedReferenceValueMappingForm:new UntypedFormControl(""), 
       selectedReferenceLibraryForm:new UntypedFormControl(""), 
       selectedReferenceGlobalObjectsListNamesForm:new UntypedFormControl(""), 
       selectedReferenceGlobalSourceObjectsListNamesForm:new UntypedFormControl(""),
       selectedGlobalExternalObjectsListNamesForm:new UntypedFormControl(""), 
       selectedRefDBObjectNameListNamesForm:new UntypedFormControl(""),
       selectedRefDBObjectNameFetchPartialsListNamesForm:new UntypedFormControl(""),
      //  fieldOrderId: new UntypedFormControl("", [Validators.required]),
      });
   }


   downloadmappingfileExtract(e) {
  console.log("inside");
  console.log(e);
  console.log(e.rowData);

  if (!e.rowData.testbedexecutionlogpath) {
    this.snackbar.open("Folder does not exist", "OK", {
      panelClass: 'snack'
    });
    return;
  }

  this.snackbar.open(
    "Download is underway. Please do not click again until it completes.",
    "OK",
    { duration: 8000 }
  );
  

  let safePath = e.rowData.testbedexecutionlogpath.replace(/\//g, "-");

  this.etlEtlService
    .download_zip(
      this.restApi.DOWNLOADSOURCEFILE +
        "/" +
        this.localStorageSettings.getSettings("AuthUsername") +
        "/" +
        this.localStorageSettings.getSettings("vaultDnsname") +
        "/" +
        "TestBed" +
        "/" +
        e.rowData.mappingtestbedid +
        "/" +
        safePath
    )
    .subscribe(
      (x) => {
        var newBlob = new Blob([x], { type: "application/zip" });
        console.log("Blob size (bytes):", newBlob.size);

        if (newBlob.size === 0) {
          this.spinner.stop();
          this.snackbar.open(
            "Download failed. Please try again after some time.",
            "OK",
            { panelClass: "snack" }
          );
          this.spinner.stop();
          return;
        }

        var sizeInMB = newBlob.size / (1024 * 1024);
        

        // Core download logic from your previous code
        const data = window.URL.createObjectURL(newBlob);
        var link = document.createElement("a");
        link.href = data;
        link.download = "TestBedTransformer" + ".zip"; // dynamic filename
        link.dispatchEvent(
          new MouseEvent("click", { bubbles: true, cancelable: true, view: window })
        );

        setTimeout(() => {
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);

        this.snackbar.open("Download Completed", "OK", { duration: 5000 });
        this.spinner.stop();
      },
      (error) => {
        console.error(error);
        this.snackbar.open("Download failed due to an error.", "OK", {
          duration: 5000
        });
        this.spinner.stop();
      }
    );
}



   async EditIcon(event){
    if(event.rowData.approvedBy === this.localStorageSettings.getSettings("AuthUsername") || event.rowData.approvedStatus != 'Approved'){
    console.log(this.mappingConfigurationData)
    console.log(this.stageObjectList)
    if (event.rowData.status == "Yes") {
     await this.getSourceTargetObjects();
      let dialogRef = this.dialog.open(AttributeMappingPopupComponent, {
        width: "90%",
        autoFocus: false,
        maxWidth: '100vw',
        height: "95%",
        disableClose: true,
        data: {
          editData: event.rowData,
          mappingConfigurationData:this.mappingConfigurationData,
          stageObjectList:this.ObjectsData,
          codeListData:this.codeListData,
          SourceId:this.SourceId,
          targetId:this.targetdnsid,
          allObjectsData:this.allObjectsList,
          codeListNamesDistinctData:this.codeListNamesDistinctData
        },
      });
  
      // subcribe the popup after close
      dialogRef.afterClosed().subscribe(result => {
        console.log(result);
        // this.getVisuals()
        if(result){
          this.spinner.start()
           let dnsId = this.localStorageSettings.getSettings("dnsName");
           this.mappingAttributeServices.retreiveMappingAttributes(dnsId).subscribe(response=>{
            if(response.error == true){
              // this.spinner.stop();
              this.mappedAttributesGrid.api.setGridOption('rowData', [])
              this.snackbar.open(response.statusMessage, "OK", {
                duration: 5000,
              });
            }else{
              console.log(response);
              this.mappedAttributesGrid.api.setGridOption('rowData', response)
              // this.spinner.stop();
            }
            this.spinner.stop();
        })
        }
      });
    } else {
      this.snackbar.open(
        "Cannot edit object group which is already deleted.",
        "OK",
        {
          duration: 8000,
        }
      );
    }
    }else{
     this.snackbar.open("Unauthorized to perform this operation for approved Mapping Attribute.", "OK", { duration: 5000 });
  }
  }
viewIcon(event) {
  this.dialog.open(AttributeMappingPopupComponent, {
    width: "90%",
    autoFocus: false,
    maxWidth: '100vw',
    height: "95%",
    disableClose: true,
    data: {
      editData: event.rowData,
      mappingConfigurationData: this.mappingConfigurationData,
      stageObjectList: this.ObjectsData,
      codeListData: this.codeListData,
      SourceId: this.SourceId,
      targetId: this.targetdnsid,
      allObjectsData: this.allObjectsList,
      codeListNamesDistinctData: this.codeListNamesDistinctData,

      isViewMode: true   
    }
  });
}
   
onObjectSelectionClearValues(){
  this.mappingAttributeDTO={
      source_attribute:[],
      target_attribute:'',
      target_attribute_list:[],
      mapping_type:'',
      mapping_logic:'',
      exceptionquery:'',
      mappingObjectId:'',
      mappingObject:'',
      source_object_id:"",
      target_object_id:"",
      source_object:'',
      target_object:'',
      tenantId:'',
      codelistname:'',
      fieldorderid:'',
      bussinesslogic:'',
      codelist_value_type:'',
       reference_source:'',
    reference_target:'',
    reference_library:'',
    reference_vault_object:'',
    reference_global_object:'',
    reference_global_source_library:'',
    global_external_object:'',
    lookupMappingDetails:'',
     reference_Database_Object_Name:"",
    reference_Database_Object_Fetch_Partial:""
    }
    this.selectedSourceAttributeList=[]
    this.selectedTargetAttribute=''
    this.expressionBuilderList=[]
    // this.selectedObjects=""
    this.buttonName="Map"
    this.expressionDetails=""
    this.exceptionExpressionDetails=""
    this.freetextDetails = ""
    this.mappingType=''
    this.targetGrid.api.setGridOption('rowData', []);
    this.sourceGrid.api.setGridOption('rowData', []); 
    // this.validations_form.reset()
    // this.formValidation()
    this.validationMessage=''
    this.syntaxValidOrNot=true;
    this.lookupButtonName="Save"
}
  


   cancel(){
    this.mappingAttributeDTO={
      source_attribute:[],
      target_attribute:'',
      target_attribute_list:[],
      mapping_type:'',
      mapping_logic:'',
      exceptionquery:'',
      mappingObjectId:'',
      mappingObject:'',
      source_object_id:"",
      target_object_id:"",
      source_object:'',
      target_object:'',
      tenantId:'',
      codelistname:'',
      fieldorderid:'',
      bussinesslogic:'',
      codelist_value_type:'',
       reference_source:'',
    reference_target:'',
    reference_library:'',
    reference_vault_object:'',
    reference_global_object:'',
    reference_global_source_library:'',
    global_external_object:'',
    lookupMappingDetails:'',
     reference_Database_Object_Name:"",
    reference_Database_Object_Fetch_Partial:""
    }
    this.selectedSourceAttributeList=[]
    this.selectedTargetAttribute=''
    this.expressionBuilderList=[]
    this.selectedObjects=""
    this.buttonName="Map"
    this.expressionDetails=""
    this.exceptionExpressionDetails=""
    this.freetextDetails = ""
    this.mappingType=''
    this.targetGrid.api.setGridOption('rowData', []);
    this.sourceGrid.api.setGridOption('rowData', []); 
    this.validations_form.reset()
    this.formValidation()
    this.validationMessage=''
    this.syntaxValidOrNot=true;
    this.lookupButtonName="Save"
   }
 deleteIcon(event) {
    if(event.rowData.approvedBy === this.localStorageSettings.getSettings("AuthUsername") || event.rowData.approvedStatus != 'Approved'){
    if (confirm("Are you sure you want to delete mapping ?")) {
    console.log(event);
    this.spinner.start();
    this.mappingAttributeServices.deleteMappingAttributes(event.rowData.mappingAttributesId).subscribe(res=>{
      if (res.error === true) {
        this.spinner.stop();
        this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
      } else {
        let dnsId = this.localStorageSettings.getSettings("dnsName");
        this.mappingAttributeServices.retreiveMappingAttributes(dnsId).subscribe(response=>{
            if(response.error == true){
              // this.spinner.stop();
              this.mappedAttributesGrid.api.setGridOption('rowData', [])
              this.snackbar.open(response.statusMessage, "OK", {
                duration: 5000,
              });
            }else{
              console.log(response);
              this.mappedAttributesGrid.api.setGridOption('rowData', response)
              // this.spinner.stop();
            }
        })
        this.spinner.stop();
        this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
      }
    })
   }
  }else{
    this.snackbar.open("Unauthorized to perform this operation for approved Mapping Attribute.", "OK", { duration: 5000 });
  }
   }


  checkIcon(event) {
    console.log(event)
    const id = event.rowData.mappingAttributesId;
    const index = this.MappingAttributecheckbox.indexOf(id);
    //retrieving the index of already inserted one to remove from the insertobject in case of uncheck
    const indexOfInsertObject = this.insertObject.findIndex(obj => obj.mappingAttributesId === id);
    if (index > -1) {
      // ID exists, so remove it
      this.MappingAttributecheckbox.splice(index, 1);
      this.MappingAttributes.splice(index,1);
      if (indexOfInsertObject !== -1) {
          console.log("Deleting object with id:", event.rowData.mappingAttributesId);
          this.insertObject.splice(indexOfInsertObject, 1);
          }
      let allApproved = true;
      

    for (let i = 0; i < this.MappingAttributes.length; i++) {

      if (this.MappingAttributes[i].approvedStatus !== 'Approved'){
          allApproved = false;
          break; // Exit loop early if any item is not 'Approve'
        }
    }

    if(this.MappingAttributes.length === 0){ 
        this.ButtonApprove = 'Approve';
        this.isvisible = true
      }

    if (this.MappingAttributes.length > 0 && allApproved) {
        this.ButtonApprove = 'Disapprove';
      }
      else{
        this.ButtonApprove = 'Approve';
      }
      
      


      
    } else {
      // ID does not exist, so add it
      this.MappingAttributecheckbox.push(id);
      this.MappingAttributes.push(event.rowData)
      //checking the selected object already present or not if not present in insertobject then add it
      if (!this.insertObject.some(obj => obj.mappingAttributesId === event.rowData.mappingAttributesId)) {
           console.log("#--------------#")
           this.insertObject.push(event.rowData);
         }
      if(event.rowData.approvedStatus === 'Approved'){
         this.ButtonApprove = 'Disapprove'
      }


      if(event.rowData.approvedStatus === null){
         this.ButtonApprove = 'Approve'
      }

      if(event.rowData.approvedStatus === 'Draft'){
         this.ButtonApprove = 'Approve'
      }

      
    }
    
    if(this.MappingAttributes.length > 0){
      this.isvisible = false
    }
    console.log(this.MappingAttributecheckbox);
    
  }
 

  async onObjectSelectionChange(event){
    if(event.value != undefined){
      this.onObjectSelectionClearValues()
    this.spinner.start();
    console.log(event);
    let selectedMappingObject = await this.mappingConfigurationData.filter(item=>item.mappingconfigurationid == event.value)[0];
    console.log(selectedMappingObject);
    this.selectedObjectMappingOrdeId=selectedMappingObject.orderId
    // stageobjectid targetobjectid
    this.selectedStageObject=[]
    let stageObject={
      objectName:selectedMappingObject.stageobject,
      objectId:selectedMappingObject.stageobjectid
    }
    this.selectedStageObject.push(stageObject)
    await this.retriveAttributesBasedOnTheMappingConfigId(selectedMappingObject,[],[]);
    
    this.spinner.stop();
    }else{
      this.sourceGrid.api.setGridOption('rowData', []);
      this.targetGrid.api.setGridOption('rowData', []); 
    }
  }

  async retriveAttributesBasedOnTheMappingConfigId(
  selectedMappingObject: any,
  stageAttributesList: any[],
  targetAttributeEditData: any[]
): Promise<void> {
  try {
    const [stageRes, targetRes] = await Promise.all([
      this.getAttributesForObject(selectedMappingObject.stageobjectid, 'stage', stageAttributesList),
      this.getAttributesForObject(selectedMappingObject.targetobjectid, 'target', targetAttributeEditData)
    ]);
  } catch (err) {
    console.error("Error in retriveAttributesBasedOnTheMappingConfigId:", err);
    this.snackbar.open("Failed to retrieve attribute data", "OK", { duration: 5000 });
  }
}

  getAttributesForObject(objectId: string, type: 'stage' | 'target', selectedList: any[]): Promise<void> {
  return new Promise((resolve, reject) => {
    this.service.retrieveTablesFieldsForDataset(objectId).subscribe({
      next: (res) => {
        if (res.error) {
          this.snackbar.open(res.message, "OK", { duration: 5000 });
          if (type === 'stage') this.sourceGrid.api.setGridOption('rowData', []);
          else this.targetGrid.api.setGridOption('rowData', []);
          return reject(res.message);
        }

        let parsedData = JSON.parse(res[0].attributeNameAndFields);
        let attributes = parsedData.datasets?.[0]?.columns || parsedData;

       for (let attr of attributes) {
          if(attr.type=="__constant"){
           attr.label= attr.name
          }else{
            attr.label = attr.alias || `${attr.label}  (${attr.name})`;
          }
        }

        if (type === 'stage') {
          this.sourceGrid.api.setGridOption('rowData', attributes);
          this.SourceAttributesDetails = attributes;
        } else {
          this.targetGrid.api.setGridOption('rowData', attributes);
          this.targetAttributeDetails = attributes;
        }

        // Pre-select matching nodes
        if (selectedList.length > 0) {
          const gridApi = type === 'stage' ? this.sourceGrid.api : this.targetGrid.api;
          gridApi.forEachNode((node) => {
            if (selectedList.some(sel => sel.name === node.data.name && sel.label === node.data.label)) {
              node.setSelected(true);
            }
          });
        }

        resolve();
      },
      error: (err) => {
        console.error(`Error fetching ${type} attributes:`, err);
        reject(err);
      }
    });
  });
}

  onGridReadyForSourceAttributes(params){
    this.sourceGrid=params;
    this.sourceGrid.api.setGridOption('rowData', []);
  }

  onGridReadyForTargetAttributes(params){
    this.targetGrid=params;
    this.targetGrid.api.setGridOption('rowData', []);
  }
  cellClickedSource(event){
   
    console.log(event);
    console.log(event.data);
    this.selectedSourceAttributeForSQlConstruction = event?.data
    this.selectedSourceAttribute=""
    if(event.node.__selected){
      this.selectedSourceAttributeList.push(event.data)
    }else{
      for(let i=0;i<this.selectedSourceAttributeList.length;i++){
        if(this.selectedSourceAttributeList[i].name == event.data.name){
          this.selectedSourceAttributeList.splice(i,1)
        }
      }
      if(this.selectedSourceAttributeList.length == 0){
        this.selectedSourceAttribute=""
        this.expressionDetails="";
      }
      console.log(this.selectedSourceAttributeList);
      
    }

//  CALLING VALIDATION HERE
if (!this.validateSingleSourceSelection()) {
  return;
}

    if(this.buttonName == "Map"){
    for(let i=0;i<this.selectedSourceAttributeList.length;i++){
      if(this.selectedSourceAttribute.length > 0){
        this.selectedSourceAttribute =  this.selectedSourceAttribute+" , "+this.selectedSourceAttributeList[i].name
      }else{
        this.selectedSourceAttribute = this.selectedSourceAttributeList[i].name
      }
    }
  }
    console.log(this.expressionDetails);
    
  }

  cellClickedTarget(event){
    console.log(event);
     this.selectedTargetAttributeForSQlConstruction = event?.data
    if(event.node.__selected){
      this.selectedTargetAttributeList=[]
    this.selectedTargetAttribute=event.data.name
    this.selectedTargetAttributeList.push(event.data)
    
    console.log(this.expressionDetails);
    }
  }
  pushDataToSelectedFieldsGrid(){

  }
  addExpression(){
    if(this.expressionDetails.length > 0){
      let expression={
        "expression":this.expressionDetails
      }
      this.expressionBuilderList.push(expression);
    }
    this.selectedSourceAttribute = ""
    for(let i=0;i<this.selectedSourceAttributeList.length;i++){
      if(this.selectedSourceAttribute.length > 0){
        this.selectedSourceAttribute =  this.selectedSourceAttribute+" , "+this.selectedSourceAttributeList[i].name
      }else{
        this.selectedSourceAttribute = this.selectedSourceAttributeList[i].name
      }
    }
    this.expressionDetails=this.selectedSourceAttribute;
  }
  addAggregateExpression(){
    let expressionData={
      sourceAttribute:this.selectedSourceAttributeForExpression,
      targetAttribute:this.selectedTargetAttributeForExpression,
      function:this.selectedFunction,
      groupByFunction:this.groupByFunction,
      conditionValue:this.conditionalValue
    }
    this.aggregateExpressionList.push(expressionData);
    console.log(this.aggregateExpressionList);
    this.selectedSourceAttributeForExpression=''
    this.selectedTargetAttributeForExpression=''
    this.selectedFunction=''
    this.groupByFunction=''
    this.conditionalValue=''
  }
  deleteExpression(k) {
    console.log(k)
    this.expressionBuilderList.splice(k, 1);
  }

  deleteAggregateExpression(k){
    this.aggregateExpressionList.splice(k, 1);
  }

  retrieveMappingDetails(dnsid){
    this.commonService.retrieveMappingConfiguration().subscribe(response => {
      // this.spinner.start();
      console.log(response);
      // checking if response is true or not
      if (response.error == true) {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        
        this.retrieveMappingTypes()
        // this.spinner.stop();
      } else {
        console.log(response)
        this.mappingConfigurationData=response;
        if(this.mappingConfigurationData.length > 0){
        this.mappingConfigurationData=this.mappingConfigurationData.map(obj => ({
          ...obj,
          combined: `${obj.stageobject}_${obj.targetobject}`
        }));
        }
        this.retrieveMappingTypes()
        // this.spinner.stop();
      }
      
    });
  }
 async mapAttributes(){
   
  if (!this.validations_form.valid) {

    // displaying validation messages
    this.validation.validateAllFormFields(this.validations_form);

    this.validation.getvalidationmessage();

  } else {
    console.log(this.selectedSourceAttributeList);
    console.log(this.selectedTargetAttribute);
    console.log(this.selectedTargetAttributeList);

    if(this.mappingType == "Direct Mapping"){
      if(this.selectedSourceAttributeList.length == 0 && this.selectedTargetAttributeList.length == 0){
            this.snackbar.open("Please select atleast one source or one target attribute", "OK", {
          duration: 5000,});
          return;
      }
    }

    if(this.mappingType == "No Mapping" || this.mappingType == "Concat Mapping" || this.mappingType == "Codelist Mapping" || this.mappingType == "Lookup Mapping"){
      if(this.selectedSourceAttributeList.length == 0){
            this.snackbar.open("Please select atleast one source attribute", "OK", {
          duration: 5000,});
          return;
      }
    }

     if(this.mappingType == "Functional Mapping" || this.mappingType == "Concat Mapping" || this.mappingType == "Codelist Mapping" || this.mappingType == "Lookup Mapping"){
      if(this.selectedTargetAttributeList.length == 0){
            this.snackbar.open("Please select atleast one target attribute", "OK", {
          duration: 5000,});
          return;
      }
    }
    
     if(this.mappingType == "Lookup Mapping"){
      if(this.expressionDetails.length == 0){
            this.snackbar.open("Please add atleast one Object,Attribute,Query details", "OK", {
          duration: 5000,});
          return;
      }
    }
    // if(this.selectedSourceAttributeList.length > 0 && this.selectedTargetAttributeList.length>0){
      if(this.mappingType == "Functional Mapping" && this.expressionDetails.length == 0){
          this.snackbar.open("Please Enter the transformation query", "OK", {
                duration: 5000,
              });
      }else{

    this.spinner.start();
    this.mappingAttributeDTO.source_attribute=this.selectedSourceAttributeList;
    this.mappingAttributeDTO.target_attribute=this.selectedTargetAttribute;
    this.mappingAttributeDTO.target_attribute_list=this.selectedTargetAttributeList
    this.mappingAttributeDTO.mapping_type=this.mappingType
    this.mappingAttributeDTO.mapping_logic=this.expressionDetails;
    this.mappingAttributeDTO.exceptionquery=this.exceptionExpressionDetails
    this.mappingAttributeDTO.mappingObjectId=this.selectedObjects
    this.mappingAttributeDTO.bussinesslogic = this.freetextDetails
    let selectedMappingObject = await this.mappingConfigurationData.filter(item=>item.mappingconfigurationid == this.selectedObjects)[0];
    console.log(selectedMappingObject);
    
    this.mappingAttributeDTO.source_object=selectedMappingObject.stageobject
    this.mappingAttributeDTO.source_object_id=selectedMappingObject.stageobjectid
    this.mappingAttributeDTO.target_object=selectedMappingObject.targetobject
    this.mappingAttributeDTO.target_object_id=selectedMappingObject.targetobjectid
    this.mappingAttributeDTO.codelistname=this.codelistName
    this.mappingAttributeDTO.fieldorderid=this.fieldOrderId
    if(this.codelistValueType == "Query"){
      this.mappingAttributeDTO.codelist_value_type="Query:"+this.codelistValueTypeQuery
    }else if(this.codelistValueType == "Constant"){
      this.mappingAttributeDTO.codelist_value_type=this.codelistValueTypeConstant
    }else{
       this.mappingAttributeDTO.codelist_value_type=this.codelistValueType
    }
   this.mappingAttributeDTO.reference_source=this.selectedReferenceSourceObjectsListNames;
   this.mappingAttributeDTO.reference_target=this.selectedReferenceTargetObjectsListNames;
   if(this.selectedReferenceValueMapping){
   this.mappingAttributeDTO.reference_library=this.selectedReferenceValueMapping.join(',');
   }else{
    this.mappingAttributeDTO.reference_library=""
   }
    this.mappingAttributeDTO.reference_vault_object=this.selectedReferenceLibraryObjectsListNames;
     this.mappingAttributeDTO.reference_global_object=this.selectedReferenceGlobalObjectsListNames
     this.mappingAttributeDTO.reference_global_source_library=this.selectedReferenceGlobalSourceObjectsListNames;
     this.mappingAttributeDTO.global_external_object=this.selectedGlobalExternalObjectsListNames;
     this.mappingAttributeDTO.reference_Database_Object_Name=this.selectedRefDBObjectNameListNames;
     this.mappingAttributeDTO.reference_Database_Object_Fetch_Partial=this.selectedRefDBObjectNameFetchPartialsListNames;
    let dnsId = this.localStorageSettings.getSettings("dnsName");
    this.mappingAttributeDTO.tenantId=dnsId
    if(this.mappingType == 'Lookup Mapping' && this.lookupMultiList.length > 0){ 
        console.log(this.lookupMultiList);
        const resultString = this.lookupMultiList
        .map(obj => `${obj.selectedStageObjectForMappingType}:${obj.dnsType}`)
        .join(';');
         this.mappingAttributeDTO.lookupMappingDetails=resultString;
    }else{
      this.mappingAttributeDTO.lookupMappingDetails=""
    }

    if(this.buttonName == "Map"){
      this.mappingAttributesId = 0;
    }
    console.log(this.mappingAttributeDTO);
    
    this.mappingAttributeServices.createMappingAttributes(this.mappingAttributeDTO,this.mappingAttributesId).subscribe(response=>{
      if(response.error == true){
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
      }else{
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        let dnsId = this.localStorageSettings.getSettings("dnsName");;
        this.mappingAttributeServices.retreiveMappingAttributes(dnsId).subscribe(response=>{
            if(response.error == true){
              // this.spinner.stop();
              this.mappedAttributesGrid.api.setGridOption('rowData', [])
              this.snackbar.open(response.statusMessage, "OK", {
                duration: 5000,
              });
            }else{
              console.log(response);
              this.mappedAttributesGrid.api.setGridOption('rowData', response)
              // this.spinner.stop();
            }
        })
        this.mappingAttributeDTO={
          source_attribute:[],
          target_attribute:'',
          target_attribute_list:[],
          mapping_logic:'',
          exceptionquery:'',
          mapping_type:'',
          mappingObjectId:'',
          mappingObject:'',
          source_object_id:"",
          target_object_id:"",
          source_object:'',
          target_object:'',
          tenantId:'',
          codelistname:'',
          fieldorderid:'',
          bussinesslogic:'',
          codelist_value_type:'',
          reference_source:'',
          reference_target:'',
          reference_library:'',
          reference_vault_object:'',
          reference_global_object:'',
          reference_global_source_library:'',
          global_external_object:'',
          lookupMappingDetails:'',
          reference_Database_Object_Name:"",
          reference_Database_Object_Fetch_Partial:""
        }
        // this.validations_form.reset()
        // this.formValidation()
        // this.selectedSourceAttributeList=[]
        // this.selectedTargetAttribute=''
        // this.expressionBuilderList=[]
        // this.selectedObjects=""
        this.buttonName="Map"
        // this.expressionDetails=""
        // this.exceptionExpressionDetails=""
        // this.freetextDetails = ""
        // this.freeEditor.setValue(this.freetextDetails)
        // this.editor.setValue(this.expressionDetails);
        // this.exceptionEditor.setValue(this.exceptionExpressionDetails)
        // this.targetGrid.api.setGridOption('rowData', []);
        // this.sourceGrid.api.setGridOption('rowData', []); 
        // this.mappingType=''
        this.spinner.stop();
      }
    })
  }
  // }else{
  //   this.snackbar.open("Please select atleast one source attribute and target attribute", "OK", {
  //     duration: 5000,
  //   });
  // }
  }
  }

   //excel export function
   onBtExport() {
    this.mappedAttributesGrid.api.exportDataAsCsv();
  }
  ///
  //pagination code
onPaginationChanged() {
if (this.mappedAttributesGrid.api) {
  this.lastpage = this.mappedAttributesGrid.api.paginationIsLastPageFound();
  this.currentpage = this.mappedAttributesGrid.api.paginationGetCurrentPage() + 1
  this.nextpage = this.mappedAttributesGrid.api.paginationGetCurrentPage() + 1 + 1
  this.nextpageplusone = this.mappedAttributesGrid.api.paginationGetCurrentPage() + 1 + 1 + 1
  this.totalpages = this.mappedAttributesGrid.api.paginationGetTotalPages()
}
}
//this function is for going to the given page number
onSearchChange(searchValue: number) {

this.mappedAttributesGrid.api.paginationGoToPage(searchValue - 1);
}

// below function is for changing the no of rows per page
onPageSizeChanged() {
var value = this.pagesize
this.mappedAttributesGrid.api.setGridOption('paginationPageSize', Number(value));
}

// below function is for going to next page
onBtNext() {
console.log("next")
this.mappedAttributesGrid.api.paginationGoToNextPage();
}

// below function for going to previous page
onBtPrevious() {
console.log("previous")
this.mappedAttributesGrid.api.paginationGoToPreviousPage();
}

// below function for going to first page
onBtFirst() {
console.log("first")
this.mappedAttributesGrid.api.paginationGoToFirstPage();
}

// below function for going to last page
onBtLast() {
console.log("last")
this.mappedAttributesGrid.api.paginationGoToLastPage();
}

refreshRun() {
}

onMappedAttributesGridReady(params){
  this.mappedAttributesGrid= params;
  let dnsId = this.localStorageSettings.getSettings("dnsName");;
  this.mappingAttributeServices.retreiveMappingAttributes(dnsId).subscribe(response=>{
     console.log(response)
      if(response.error == true){
        // this.spinner.stop();
        this.mappedAttributesGrid.api.setGridOption('rowData', [])
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
      }else{
        console.log(response);
        this.mappedAttributesGrid.api.setGridOption('rowData', response)
        // this.spinner.stop();
      }
  })
}

validateSQL(){
  this.spinner.start();
  let sqlQuery={
    "sqlQuery":this.expressionDetails
  }
  this.mappingAttributeServices.validateSQLQuery(sqlQuery).subscribe(response=>{
    if(response.error == true){
      this.spinner.stop();
      this.snackbar.open("❌ Not a valid syntax", "OK", {
        duration: 5000,
      });
      this.validationMessage="❌ Not a valid syntax"
      this.syntaxValidOrNot=false;
    }else{
      console.log(response);
      this.snackbar.open(response.statusMessage, "OK", {
        duration: 5000,
      });
      this.validationMessage=response.statusMessage
      this.syntaxValidOrNot=true;
      this.spinner.stop();
    }
  })
}
onMappingTypeChange(event){
  this.lookupMultiList=[]
if(event.value == "Codelist Mapping"){
  this.validations_form.controls["codelistname"].setValidators([Validators.required]);
  this.validations_form.controls["codelistname"].updateValueAndValidity();
  this.validations_form.controls["codelistValueType"].setValidators([Validators.required]);
  this.validations_form.controls["codelistValueType"].updateValueAndValidity();
  this.validations_form.controls["selectStageObjectsForm"].clearValidators();
  this.validations_form.controls["selectStageObjectsForm"].updateValueAndValidity()
  this.validations_form.controls["selectStageObjectsAttributesForm"].clearValidators();
  this.validations_form.controls["selectStageObjectsAttributesForm"].updateValueAndValidity()
  this.validations_form.controls["query"].clearValidators();
  this.validations_form.controls["query"].updateValueAndValidity();
  //  this.editor.setOption('readOnly', false ? 'nocursor' : false);
}else if(event.value == 'Lookup Mapping' ){
   this.validations_form.controls["selectStageObjectsForm"].clearValidators();
  this.validations_form.controls["selectStageObjectsForm"].updateValueAndValidity()
  this.validations_form.controls["selectStageObjectsAttributesForm"].clearValidators();
  this.validations_form.controls["selectStageObjectsAttributesForm"].updateValueAndValidity()
    this.validations_form.controls["query"].clearValidators();
  this.validations_form.controls["query"].updateValueAndValidity();
   this.validations_form.controls["codelistname"].clearValidators();
  this.validations_form.controls["codelistname"].updateValueAndValidity();
   this.validations_form.controls["codelistValueType"].setValidators([Validators.required]);
  this.validations_form.controls["codelistValueType"].updateValueAndValidity();
  // this.editor.setOption('readOnly', true ? 'nocursor' : false);
  this.getSourceTargetObjects()
}else if(event.value == 'Concat Mapping' ){
 this.validations_form.controls["codelistname"].clearValidators();
  this.validations_form.controls["codelistname"].updateValueAndValidity();
  this.validations_form.controls["codelistValueType"].clearValidators();
  this.validations_form.controls["codelistValueType"].updateValueAndValidity();
  this.validations_form.controls["selectStageObjectsForm"].clearValidators();
  this.validations_form.controls["selectStageObjectsForm"].updateValueAndValidity()
  this.validations_form.controls["selectStageObjectsAttributesForm"].clearValidators();
  this.validations_form.controls["selectStageObjectsAttributesForm"].updateValueAndValidity()
  this.validations_form.controls["query"].setValidators([Validators.required]);
  this.validations_form.controls["query"].updateValueAndValidity();
  //  this.editor.setOption('readOnly', true ? 'nocursor' : false);
}else{
  this.validations_form.controls["codelistname"].clearValidators();
  this.validations_form.controls["codelistname"].updateValueAndValidity();
  this.validations_form.controls["codelistValueType"].clearValidators();
  this.validations_form.controls["codelistValueType"].updateValueAndValidity();
  this.validations_form.controls["selectStageObjectsForm"].clearValidators();
  this.validations_form.controls["selectStageObjectsForm"].updateValueAndValidity()
  this.validations_form.controls["selectStageObjectsAttributesForm"].clearValidators();
  this.validations_form.controls["selectStageObjectsAttributesForm"].updateValueAndValidity()
    this.validations_form.controls["query"].clearValidators();
  this.validations_form.controls["query"].updateValueAndValidity();
  //  this.editor.setOption('readOnly', false ? 'nocursor' : false);
}
if(event.value == 'Functional Mapping'){
  this.getSourceReferenceObjects()
}
 this.mappingType = event.value;
 this.validateSingleSourceSelection();
}
onCodelistDefalutValueTypeChange(){
 if(this.codelistValueType == "Query"){
    this.validations_form.controls["codelistValueTypeQuery"].setValidators([Validators.required]);
    this.validations_form.controls["codelistValueTypeQuery"].updateValueAndValidity();
    this.validations_form.controls["codelistValueTypeConstant"].clearValidators();
    this.validations_form.controls["codelistValueTypeConstant"].updateValueAndValidity();
  }else if(this.codelistValueType == "Constant"){
    this.validations_form.controls["codelistValueTypeConstant"].setValidators([Validators.required]);
    this.validations_form.controls["codelistValueTypeConstant"].updateValueAndValidity();
    this.validations_form.controls["codelistValueTypeQuery"].clearValidators();
    this.validations_form.controls["codelistValueTypeQuery"].updateValueAndValidity();
  }else{
    this.validations_form.controls["codelistValueTypeQuery"].clearValidators();
    this.validations_form.controls["codelistValueTypeQuery"].updateValueAndValidity();
    this.validations_form.controls["codelistValueTypeConstant"].clearValidators();
    this.validations_form.controls["codelistValueTypeConstant"].updateValueAndValidity();
  }
}
ngAfterViewInit() {
  
}



onRunBtNext1() {
    console.log("next")
    this.gridAPIValidation.paginationGoToNextPage();
  }

  // below function for going to previous page
  onRunBtPrevious1() {
    console.log("previous")
    this.gridAPIValidation.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onRunBtFirst1() {
    this.gridAPIValidation.paginationGoToFirstPage();
  }

  // below function for going to last page
  onRunBtLast1() {
    this.gridAPIValidation.paginationGoToLastPage();
  }
   

  

  onloadPaginationChanged1(){
    if (this.gridAPIValidation) {
      this.RunlastPage1 = this.gridAPIValidation.paginationIsLastPageFound();
      this.RuncurrentPage1 = this.gridAPIValidation.paginationGetCurrentPage() + 1
      this.RunnextPage1 = this.gridAPIValidation.paginationGetCurrentPage() + 1 + 1
      this.RunnextPagePlusOne1 = this.gridAPIValidation.paginationGetCurrentPage() + 1 + 1 + 1
      this.RuntotalPages1 = this.gridAPIValidation.paginationGetTotalPages()
    }
  }

  retrieveInstructionsBasedOnActivity(params){
        this.refresh_params = params
        this.gridAPIValidation = params.api;
        this.gridAPIValidation.setGridOption('rowData', [])
        this.mappingAttributeServices
          .retrivemappingtestbedexecution(this.localStorageSettings.getSettings("WorkspaceId"))
          .subscribe((response: any) => {   // use 'any' or define proper array type
            
            // response is now treated as an array
            const filteredResponse = (response as any[]).filter(row => row.verificationtype != "Stage");
            
            this.gridAPIValidation.setGridOption('rowData', filteredResponse);
          });

      }

   refreshh(){
    this.spinner.start()
    this.retrieveInstructionsBasedOnActivity(this.refresh_params)
    this.spinner.stop()

   }


  onRunSearchChange(searchValue: number) {
    this.gridAPIValidation.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onRunPageSizeChanged(newPageSize) {
    var value = this.RunpageSize1;
    this.gridAPIValidation.setGridOption('paginationPageSize', Number(value));
  }



openSqlBuilderPopUpForTransformation(){
  let Query = this.expressionDetails;
  console.log(Query);
  
 let dialogRef = this.dialog.open(SqlEditorPopupComponent, { 
        width: "90%",
        autoFocus: false,
        maxWidth: '100vw',
        height: "95%",
        disableClose: true,
        data: { objectList: this.selectedStageObject,Query:Query},
      });
      dialogRef.afterClosed().subscribe(result => {
        console.log(result);
        this.expressionDetails = result;
      })  
}
openSqlBuilderPopUpForException(){
   let Query = this.exceptionExpressionDetails;
  let dialogRef = this.dialog.open(SqlEditorPopupComponent, { 
         width: "90%",
         autoFocus: false,
         maxWidth: '100vw',
         height: "95%",
         disableClose: true,
         data: { objectList: this.selectedStageObject,Query:Query},
       });
       dialogRef.afterClosed().subscribe(result => {
         console.log(result);
        //  this.editor.setValue(result);
         this.exceptionExpressionDetails = result;
       })  
 }

openBaselineView(){
  let dialogRef = this.dialog.open(BaselineMappingViewPopupComponent, { 
    width: "90%",
    autoFocus: false,
    maxWidth: '80vw',
    height: "80%",
    disableClose: true,
    data: {},
  });
}


// 
Mappingverify() {

  if (this.MappingAttributecheckbox.length === 0) {
    this.snackbar.open("Select Atleast One Mapping Attribute", "OK", { duration: 5000 });
    return;
  }

  //  Restrict to max 5
  if (this.MappingAttributecheckbox.length > 5) {
    this.snackbar.open("You can select maximum 5 records only", "OK", { duration: 5000 });
    return;
  }

  //  Validate same source_object & target_object
  const first = this.insertObject[0];

  const allSame = this.insertObject.every(item =>
    item.source_object === first.source_object &&
    item.target_object === first.target_object
  );

  if (!allSame) {
    this.snackbar.open(
      "Please select rows with same Source Object and Target Object",
      "OK",
      { duration: 5000 }
    );
    return;
  }

  //  OPEN POPUP (existing flow)
  let dialogRef = this.dialog.open(VerifyMappingComponent, {
    panelClass: 'custom-dialog-container-materialFulfilment',
    width: '80%',
    autoFocus: false,
    data: { edata: this.insertObject, screen: "Verify Mapping" },
    disableClose: true,
  });

  this.insertObject = [];

  dialogRef.afterClosed().subscribe(() => {
    this.MappingAttributecheckbox = [];
    this.MappingAttributes = [];
    this.onMappedAttributesGridReady(this.mappedAttributesGrid);
  });

  this.isvisible = true;
}

generateSQL() {
  const sqlText = this.freetextDetails ; // 👈 Get current content from CodeMirror
  console.log('Generated SQL:', sqlText);
// this.sql="query"
this.spinner.start();
 this.commonService.getSqlForBussinesslogic(this.SourceAttributesDetails,this.targetAttributeDetails,this.selectedSourceAttributeForSQlConstruction,this.selectedTargetAttributeForSQlConstruction,sqlText).subscribe(response=>{
    console.log(response)
      if(response.error == true){
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
      }else{
       this.sql = response.sql;
        this.spinner.stop();
          let dialogRef = this.dialog.open(TextAreaComponent, {
              panelClass: 'custom-dialog-container-materialFulfilment',
              width: '75%',
              height:'60%',
              maxWidth:'100vw',
              autoFocus: false,
              data: { edata:this.sql },
              disableClose: true,
            });
            dialogRef.afterClosed().subscribe(result => {
          
          })
      }
    })
  
}
 
    getRouterLink(event): any[] {
      if (event.label === 'Objects') {
        return ['/user/Menubar/trnxBaseComponent'];
      } else {
        return [`/user/Menubar/${event.link}`];
      }
    }

getQueryParams(label: string): any {
  if (label === 'Objects') {
    return {
      screenType: 'Dynamic/Transactions',
      tableName: 'objectmetadata',
      headerNameHtml: 'Objects'
    };
  }
  return null;
}


  Viewresults(){
  if (this.MappingAttributecheckbox.length > 0) {
  let dialogRef = this.dialog.open(ViewResultsComponent, {
        panelClass: 'custom-dialog-container-materialFulfilment',
        width: '80%',
        autoFocus: false,
        data: { edata: this.MappingAttributecheckbox,screen:"Verify Mapping"},
        disableClose: true,
      });
    

    dialogRef.afterClosed().subscribe((description: string) => {
          this.MappingAttributecheckbox = []
          this.MappingAttributes = []
          this.insertObject = []
          this.onMappedAttributesGridReady(this.mappedAttributesGrid)
        });
      }
      else{
  this.snackbar.open("Select Atleast One Mapping Attribute", "OK", { duration: 5000 });
 }
 this.isvisible = true;
}


ApproveAttribute() {
  if (this.MappingAttributes.length === 0) {
    this.snackbar.open("Select Atleast One Mapping Attribute", "OK", { duration: 5000 });
    return;
  }
  
  this.isvisible = true;
  let firstStatus = this.MappingAttributes[0].approvedStatus;


  let allSame = this.MappingAttributes.every(attr => {
  return (firstStatus === null || firstStatus === 'Draft')
    ? (attr.approvedStatus === null || attr.approvedStatus === 'Draft')
    : (attr.approvedStatus === firstStatus);
  });

  if (!allSame) {
  this.snackbar.open("Please select only one combination of mapping attributes for approval or disapproval.", "OK", { duration: 5000 });
  return;
  }



  let approvedStatus = this.ButtonApprove === 'Approve' ? 'Approved' :
                       this.ButtonApprove === 'Disapprove' ? 'Draft' : null;

  if (!approvedStatus) {
    this.snackbar.open("Invalid action. Please select Approve or Disapprove.", "OK", { duration: 5000 });
    return;
  }

  let response = {
    approvedStatus: approvedStatus,
    approvedBy: this.localStorageSettings.getSettings("AuthUsername")
  };
  this.spinner.start();
  this.mappingAttributeServices.updateAttibuteSatus(response, this.MappingAttributecheckbox).subscribe(response => {
    this.MappingAttributecheckbox = [];
    this.MappingAttributes = []
    this.onMappedAttributesGridReady(this.mappedAttributesGrid);
    this.ButtonApprove = 'Approve'
    this.spinner.stop()
    this.snackbar.open(response.data, "OK", { duration: 5000 });
  });
}






retrieveSourceAndTarget() {
  const dnsId =  this.localStorageSettings.getSettings("WorkspaceId")
  this.spinner.start();
  this.etlservice.retrieveSourceAndTraget(dnsId, "Source").subscribe({
    next: (result) => {
      console.log(result);
      if (result === null) {
        console.log("No Data Found");
      } else {
        this.SourceId = result.sourceId
         this.targetdnsid = result.targetId
      }
       this.retrieveMappingDetails(dnsId)
    },
    error: (err) => {
       this.retrieveMappingDetails(dnsId)
      console.error("Error snapshotDetails:", err);
      // this.spinner.stop();
    }
  });
}
 getStageObjects() {
    this.linkservice.retrieveStageObject(this.SourceId).subscribe(response => {
      console.log("API Response after Insert:", response);
      
        if (response.error) {
          this.snackbar.open(response.statusMessage, "OK", { duration: 5000 });
        } else {
          console.log("************************************************************");
          this.stageObjectList=response
          console.log(response)
        }
        this.spinner.stop();
    });
  }
getCompleteObjectsData(){
  this.spinner.start();
    this.commonService.retrieveObjectGroupObjectsbasedDns(this.SourceId).subscribe(response=>{
      if(response.error == true){
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
      }else{
       this.ObjectsData = response;
        this.spinner.stop();
      }
    })
}
searchableObjects(){
  if(this.ObjectsData.length > 0){
        var columndata = []
      var c = {
        "objectlabel": "Object Label",
        "objectname":"Object Name",
        "dnsType":"Type",
        "status":"Status",
      } 
     columndata.push(c)
     
     let selectedObject;
     if(this.selectedStageObjectForMappingType){
      selectedObject={
      objectname:this.selectedStageObjectForMappingType,
      dnsType:this.selectedStageObjectDetails.dnsType
     }
     }else{
      selectedObject=this.selectedStageObjectForMappingType
     }
      let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
        width: "50%",
        autoFocus: false,
        disableClose: true,
        data: { 
          edata:this.allObjectsList,
          page:"single",
          columns:columndata,
          selectedValue:[selectedObject],
          selectedPropertyName:"objectname"
        }
      });
       dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result != undefined) {
        if(result.selectedRows.length > 0){
        this.selectedStageObjectForMappingType=result.selectedRows[0].objectname;
        this.selectedStageObjectDetails=result.selectedRows[0];
        console.log(this.selectedStageObjectDetails);
        if(this.selectedStageObjectDetails.dnsType !="ValueMapping"){
          const objectAttributes = result.selectedRows[0].objectattributes ? JSON.parse(result.selectedRows[0].objectattributes) : {};
          const attributesJson= result.selectedRows[0].objectattributes ? JSON.stringify(JSON.parse(result.selectedRows[0].objectattributes), null, 2):"";
          const columns=JSON.parse(attributesJson)
          if(columns.datasets){
            this.selectedStageObjectAttributesList=columns.datasets[0].columns;
          }else{
            this.selectedStageObjectAttributesList=columns;
          }
          
          console.log(this.selectedStageObjectAttributesList);
          this.selectedStageObjectAttributeForMappingType=null
          //  this.createTransformationQuery()
        }else{
          this.spinner.start();
          this.valueMappingservice.retreiveFieldMapping(this.selectedStageObjectDetails.mappingTypeId).subscribe(response=>{
            if(response.error == true){
               this.spinner.stop();
            }else{
              let getdata:any=response
              let data:any = JSON.parse(getdata.mappedFieldsData)
              console.log(data);
              let headers=JSON.parse(getdata.mappedFields)
              if(headers){
                console.log(headers);
                this.valueMappingHeaders=[]
                this.valueMappingHeaders.push(...headers.SourceColumns)
                this.valueMappingHeaders.push(...headers.TargetColumns)
                // this.headersDataDetails=headers
                console.log(this.valueMappingHeaders);
                 this.selectedStageObjectAttributesList=this.valueMappingHeaders
              }
              // if(getdata.mappedFieldsData != null){
              //   let rowData=JSON.parse(getdata.mappedFieldsData)
              //   console.log(rowData);
              //   this.selectedStageObjectAttributesList=rowData;
              // }
               this.spinner.stop();
            }
          })
        }
        }else{
           this.selectedStageObjectForMappingType=null;
           this.selectedStageObjectDetails=null;
            this.selectedStageObjectAttributeForMappingType=null
            this.selectedStageObjectAttributesList=[]
        }
      }
      })
    }
}

searchableAttributes(){
  if(!this.selectedStageObjectForMappingType){
    this.selectedStageObjectAttributesList=[]
  }
 if(this.selectedStageObjectAttributesList.length > 0){
        var columndata = []
      console.log(this.selectedStageObjectDetails)
      let selectedPropertyNameDetails;
     if(this.selectedStageObjectDetails.dnsType =="ValueMapping"){
      var headers={
        "label": "Label",
      }
       columndata.push(headers)
       selectedPropertyNameDetails="label"
     }else{
      var c = {
        "label": "Attribute Label",
        "name":"Attribute Name",
        "alias":"Attribute Alias",
      }
     columndata.push(c)
     selectedPropertyNameDetails="name"
     }
      let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
        width: "60%",
        autoFocus: false,
        disableClose: true,
        data: { 
          edata:this.selectedStageObjectAttributesList,
          page:"single",
          columns:columndata,
          selectedValue:[this.selectedStageObjectAttributeForMappingType],
          selectedPropertyName:selectedPropertyNameDetails
        }
      });
       dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result != undefined) {
        if(result.selectedRows.length > 0){
          if(this.selectedStageObjectDetails.dnsType =="ValueMapping"){
            this.selectedStageObjectAttributeForMappingType=result.selectedRows[0].label;
          }else{
            this.selectedStageObjectAttributeForMappingType=result.selectedRows[0].name;
          }
           
          //  this.createTransformationQuery()
        }else{
           this.selectedStageObjectAttributeForMappingType=null;
        }
       
        
      }
      })
    }
}
createTransformationQuery(){
  console.log("********************************************TTTTT");
  // let transformQuery=this.selectedStageObjectForMappingType+","+this.selectedStageObjectAttributeForMappingType+","+this.query
  // console.log(transformQuery)
  let transformQuery = [
  this.selectedStageObjectForMappingType,
  this.selectedStageObjectAttributeForMappingType,
  this.query
]
.filter(value => value !== null && value !== undefined && value !== '')
.join(',');
console.log(transformQuery)
console.log(this.lookupMultiList);

let transformedQuery;
for(let i=0;i<this.lookupMultiList.length;i++){
  if(i==0){
    transformedQuery=[
  this.lookupMultiList[i].selectedStageObjectForMappingType,
  this.lookupMultiList[i].selectedStageObjectAttributeForMappingType,
  this.lookupMultiList[i].query
]
.filter(value => value !== null && value !== undefined && value !== '')
.join(',');
  }else{
    let query=[
  this.lookupMultiList[i].selectedStageObjectForMappingType,
  this.lookupMultiList[i].selectedStageObjectAttributeForMappingType,
  this.lookupMultiList[i].query
]
.filter(value => value !== null && value !== undefined && value !== '')
.join(',');
    transformedQuery=transformedQuery+";Lookup:"+query;
  }
}
console.log(transformedQuery);
if(transformedQuery){
this.expressionDetails=transformedQuery
}else{
  this.expressionDetails=''
}


}
 retrieveMappingTypes(){
    // this.spinner.start();
    let dnsId = this.localStorageSettings.getSettings("dnsName");
    this.valueMappingservice.retreiveMappingTypes(dnsId).subscribe(response=>{
      if(response.error == true){
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", { 
          duration: 5000,
        });
        
         this.getCompleteObjectsData();
      }else{
        
        console.log(response);
        this.codeListData=response;
        if( this.codeListData.length > 0){
        
        
        let codeListMappingId =  this.codeListData.filter(item=>item.mappingTypeName == "Codelist_Mapping")
        console.log(codeListMappingId);
        
        this.getCodeListMappingDetails(codeListMappingId[0].mappingTypeId)
      }
         this.getCompleteObjectsData();
        // this.spinner.stop();
      }
    })
  }

excelFileUpload(){
  const tablename='mappingattributes'
  let dialogRef = this.dialog.open(UploadExcelFileComponent, {
              panelClass: 'custom-dialog-container-materialFulfilment',
              width: '95%',
              height:'80%',
              maxWidth:'100vw',
              autoFocus: false,
              data: { edata:tablename },
              disableClose: true,
            });
            dialogRef.afterClosed().subscribe(result => {
            console.log(result)
             if(result){
              this.excelData = result
            //  this.sendExcelData()
          this.onMappedAttributesGridReady(this.mappedAttributesGrid)
             }
               this.onMappedAttributesGridReady(this.mappedAttributesGrid)
            //  input.value = '';
          })
      
      }

searchableReferenceSourceObjects(){
     if(this.referenceSourceObjectsList.length > 0){
            var columndata = []
          var c = {
            "objectlabel": "Object Label",
            "objectname":"Object Name"
          } 
         columndata.push(c)
         let selectedList=[];
         if(this.selectedReferenceSourceObjectsList.length >0){
            selectedList = this.selectedReferenceSourceObjectsList;
         }
          let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
            width: "50%",
            autoFocus: false,
            disableClose: true,
            data: { 
              edata:this.referenceSourceObjectsList,
              page:"multiple",
              columns:columndata,
              selectedValue:selectedList,
              selectedPropertyName:"objectname"
            }
          });
           dialogRef.afterClosed().subscribe(result => {
          console.log(result);
          if (result != undefined) {
            console.log(result.selectedRows);
            this.selectedReferenceSourceObjectsList=result.selectedRows.map((item: any) => item.objectname);
           this.selectedReferenceSourceObjectsListNames =result.selectedRows.map(item => item.objectname).join(',');
          }
          })
        }
  }
  searchableReferenceTargetObjects(){
     if(this.mappingConfigurationData.length > 0){
 let filteredObjectMappingBasedOnOrderIdList = this.mappingConfigurationData.filter(item =>
      item.orderId !== null && item.orderId < this.selectedObjectMappingOrdeId
    ).sort((a, b) => a.orderId - b.orderId);

    console.log(filteredObjectMappingBasedOnOrderIdList);
    
            var columndata = []
          var c = {
            "orderId":"Order Id",
             "combined": "Reference Transform",
          } 
         columndata.push(c)
         let selectedList=[]
         if(this.selectedReferenceTargetObjectsList.length > 0){
          for(let i=0;i<this.selectedReferenceTargetObjectsList.length;i++){
            let subObjects=this.selectedReferenceTargetObjectsList[i].split("--")
            let objects={
              "stageobject":subObjects[0],
              "targetobject":subObjects[1]
            }
             selectedList.push(objects)
          }
         
         }
         console.log(selectedList);
         
          let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
            width: "50%",
            autoFocus: false,
            disableClose: true,
            data: { 
              edata:filteredObjectMappingBasedOnOrderIdList,
              page:"multiple",
              columns:columndata,
              selectedValue:selectedList,
              selectedPropertyName:"stageobject"
            }
          });
           dialogRef.afterClosed().subscribe(result => {
          console.log(result);
          if (result != undefined) {
            console.log(result.selectedRows);
            this.selectedReferenceTargetObjectsList=result.selectedRows.map((item: any) => item.stageobject+"--"+item.targetobject)
           this.selectedReferenceTargetObjectsListNames = result.selectedRows.map(item => item.stageobject+"--"+item.targetobject).join(',');
             console.log();
                                                      
          }
          })
        }
  }
   searchableReferenceLibraryObjects(){
     if(this.referenceLibraryObjectsList.length > 0){
            var columndata = []
          var c = {
             "objectlabel": "Object Label",
            "objectname":"Object Name"
          } 
         columndata.push(c)
         let selectedList=[]
         if(this.selectedReferenceLibraryObjectsList.length > 0){
          selectedList=this.selectedReferenceLibraryObjectsList;
         }
          let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
            width: "50%",
            autoFocus: false,
            disableClose: true,
            data: { 
              edata:this.referenceLibraryObjectsList,
              page:"multiple",
              columns:columndata,
              selectedValue:selectedList,
              selectedPropertyName:"objectname"
            }
          });
           dialogRef.afterClosed().subscribe(result => {
          console.log(result);
          if (result != undefined) {
            console.log(result.selectedRows);
            this.selectedReferenceLibraryObjectsList=result.selectedRows.map((item: any) => item.objectname)
           this.selectedReferenceLibraryObjectsListNames = result.selectedRows.map(item => item.objectname).join(',');
             console.log();
                                                      
          }
          })
        }
  }
  searchableReferenceGlobalObjects(){
     if(this.referenceGlobalObjectsList.length > 0){
            var columndata = []
          var c = {
            "objectlabel": "Object Label",
            "objectname":"Object Name"
          } 
         columndata.push(c)
         let selectedList=[];
         if(this.selectedReferenceGlobalObjectsList.length >0){
            selectedList = this.selectedReferenceGlobalObjectsList;
         }
          let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
            width: "50%",
            autoFocus: false,
            disableClose: true,
            data: { 
              edata:this.referenceGlobalObjectsList,
              page:"multiple",
              columns:columndata,
              selectedValue:selectedList,
              selectedPropertyName:"objectname"
            }
          });
           dialogRef.afterClosed().subscribe(result => {
          console.log(result);
          if (result != undefined) {
            console.log(result.selectedRows);
            this.selectedReferenceGlobalObjectsList=result.selectedRows.map((item: any) => item.objectname);
           this.selectedReferenceGlobalObjectsListNames =result.selectedRows.map(item => item.objectname).join(',');
          }
          })
        }
  }

  searchableReferenceGlobalSourceObjects(){
     if(this.referenceSourceGlobalObjectsList.length > 0){
            var columndata = []
          var c = {
            "objectlabel": "Object Label",
            "objectname":"Object Name"
          } 
         columndata.push(c)
         let selectedList=[];
         if(this.selectedReferenceGlobalSourceObjectsList.length >0){
            selectedList = this.selectedReferenceGlobalSourceObjectsList;
         }
          let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
            width: "50%",
            autoFocus: false,
            disableClose: true,
            data: { 
              edata:this.referenceSourceGlobalObjectsList,
              page:"multiple",
              columns:columndata,
              selectedValue:selectedList,
              selectedPropertyName:"objectname"
            }
          });
           dialogRef.afterClosed().subscribe(result => {
          console.log(result);
          if (result != undefined) {
            console.log(result.selectedRows);
            this.selectedReferenceGlobalSourceObjectsList=result.selectedRows.map((item: any) => item.objectname);
           this.selectedReferenceGlobalSourceObjectsListNames =result.selectedRows.map(item => item.objectname).join(',');
          }
          })
        }
  }
  searchableGlobalExternalObjects(){
     if(this.referenceExternalObjectsList.length > 0){
            var columndata = []
          var c = {
            "objectlabel": "Object Label",
            "objectname":"Object Name"
          } 
         columndata.push(c)
         let selectedList=[];
         if(this.selectedGlobalExternalObjectsList.length >0){
            selectedList = this.selectedGlobalExternalObjectsList;
         }
          let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
            width: "50%",
            autoFocus: false,
            disableClose: true,
            data: { 
              edata:this.referenceExternalObjectsList,
              page:"multiple",
              columns:columndata,
              selectedValue:selectedList,
              selectedPropertyName:"objectname"
            }
          });
           dialogRef.afterClosed().subscribe(result => {
          console.log(result);
          if (result != undefined) {
            console.log(result.selectedRows);
            this.selectedGlobalExternalObjectsList=result.selectedRows.map((item: any) => item.objectname);
           this.selectedGlobalExternalObjectsListNames =result.selectedRows.map(item => item.objectname).join(',');
          }
          })
        }
  }

  searchableTargetObjectsForRefDBObjectName(){
         if(this.referenceTargetObjectsList.length > 0){
                var columndata = []
              var c = {
                "objectlabel": "Object Label",
                "objectname":"Object Name"
              } 
             columndata.push(c)
             let selectedList=[];
             if(this.selectedRefDBObjectNameList.length >0){
                selectedList = this.selectedRefDBObjectNameList;
             }
              let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
                width: "50%",
                autoFocus: false,
                disableClose: true,
                data: { 
                  edata:this.referenceTargetObjectsList,
                  page:"multiple",
                  columns:columndata,
                  selectedValue:selectedList,
                  selectedPropertyName:"objectname"
                }
              });
               dialogRef.afterClosed().subscribe(result => {
              console.log(result);
              if (result != undefined) {
                console.log(result.selectedRows);
                this.selectedRefDBObjectNameList=result.selectedRows.map((item: any) => item.objectname);
               this.selectedRefDBObjectNameListNames =result.selectedRows.map(item => item.objectname).join(',');
              }
              })
            }
      }
  
      
    searchableTargetObjectsForRefDBObjectNameFetchPartials(){
         if(this.referenceTargetObjectsList.length > 0){
                var columndata = []
              var c = {
                "objectlabel": "Object Label",
                "objectname":"Object Name"
              } 
             columndata.push(c)
             let selectedList=[];
             if(this.selectedRefDBObjectNameFetchPartialsList.length >0){
                selectedList = this.selectedRefDBObjectNameFetchPartialsList;
             }
              let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
                width: "50%",
                autoFocus: false,
                disableClose: true,
                data: { 
                  edata:this.referenceTargetObjectsList,
                  page:"multiple",
                  columns:columndata,
                  selectedValue:selectedList,
                  selectedPropertyName:"objectname"
                }
              });
               dialogRef.afterClosed().subscribe(result => {
              console.log(result);
              if (result != undefined) {
                console.log(result.selectedRows);
                this.selectedRefDBObjectNameFetchPartialsList=result.selectedRows.map((item: any) => item.objectname);
               this.selectedRefDBObjectNameFetchPartialsListNames =result.selectedRows.map(item => item.objectname).join(',');
              }
              })
            }
      }

  getSourceReferenceObjects(){
     this.spinner.start();
      this.commonService.retrieveObjectGroupObjectsbasedDns(this.SourceId).subscribe(res=>{
            if (res.error === true) {
                // this.ObjectGrid.api.setGridOption('rowData', []);
            } else {
               
                console.log(res);
                const objects = res.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
               
                this.referenceSourceObjectsList = objects;
                 this.commonService.getlookupVauleByLookUpType("Vault Object Group").subscribe(result => {
                  console.log(result);
                  // this.mappingTypeDataDropDown = result;
                  // console.log(this.mappingTypeDataDropDown)
                 let lookupDetails:any=result
                  let ExternalLookupValue=lookupDetails.filter(item=>item.lookupcode=="External")
                  this.referenceLibraryObjectsLookupValue=lookupDetails.filter(item=>item.lookupcode=="Library");
                  this.referenceGlobalObjectsLookupValue=lookupDetails.filter(item=>item.lookupcode=="Global");
                  console.log(ExternalLookupValue);
                  let lookupValueId=ExternalLookupValue[0].lookupvalueid
                  const externalObjects = res.filter(item=>item.objecttype == lookupValueId);
                  console.log(externalObjects);
                  
                   this.referenceExternalObjectsList=externalObjects.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                let globalLookupId=this.referenceGlobalObjectsLookupValue[0].lookupvalueid
                const globalObjects=res.filter(item=>item.objecttype == globalLookupId);
                this.referenceSourceGlobalObjectsList=globalObjects.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                 })
                this.getTargetReferenceObjects();
            }
            
    })
  }
  getTargetReferenceObjects(){

        this.commonService.retrieveNonStageObjectsbasedDns(this.targetdnsid).subscribe(res=>{
            if (res.error === true) {
                // this.ObjectGrid.api.setGridOption('rowData', []);
                 this.spinner.stop();
            } else {
              
                console.log(res);
                const objects = res.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                  this.referenceTargetObjectsList = objects;
                  let lookupValueId=this.referenceLibraryObjectsLookupValue[0].lookupvalueid
                  const LibraryObjects = res.filter(item=>item.objecttype == lookupValueId);
                  
                   this.referenceLibraryObjectsList=LibraryObjects.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                console.log(this.referenceLibraryObjectsList);

                 let globalLookupValueId=this.referenceGlobalObjectsLookupValue[0].lookupvalueid
                  const GlobalObjects = res.filter(item=>item.objecttype == globalLookupValueId);
                  
                   this.referenceGlobalObjectsList=GlobalObjects.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                   this.spinner.stop();
            }
            
    });
  }
  createTransformationQueryConcat(){
      console.log("********************************************TTTTT");
      // let transformQuery=this.selectedStageObjectForMappingType+","+this.selectedStageObjectAttributeForMappingType+","+this.query
      // console.log(transformQuery)
      let transformQuery = [
      this.selectedStageObjectForMappingType,
      this.selectedStageObjectAttributeForMappingType,
      this.query
    ]
    .filter(value => value !== null && value !== undefined && value !== '')
    .join(',');
    console.log(transformQuery)
    this.expressionDetails=transformQuery
}
  addWhere(){
     if(!this.selectedStageObjectForMappingType || this.selectedStageObjectForMappingType.trim().length ==0){
      this.snackbar.open("Please add Object", "OK", {
          duration: 5000,
        });
        return;
    }

    if(!this.selectedStageObjectAttributeForMappingType || this.selectedStageObjectAttributeForMappingType.trim().length ==0){
      this.snackbar.open("Please add Attribute", "OK", {
          duration: 5000,
        });
        return;
    }
    if(!this.query || this.query.trim().length ==0){
      this.snackbar.open("Please add Query", "OK", {
          duration: 5000,
        });
        return;
    }
    if(this.lookupButtonName=="Update"){
      this.lookupMultiList[this.lookUpIndex].selectedStageObjectForMappingType=this.selectedStageObjectForMappingType
      this.lookupMultiList[this.lookUpIndex].selectedStageObjectAttributeForMappingType=this.selectedStageObjectAttributeForMappingType
      this.lookupMultiList[this.lookUpIndex].query=this.query
      this.lookupMultiList[this.lookUpIndex].dnsType=this.selectedStageObjectDetails.dnsType
      
    }else{
    let item ={
      index:this.lookupMultiList.length,
      selectedStageObjectForMappingType:this.selectedStageObjectForMappingType,
      selectedStageObjectAttributeForMappingType:this.selectedStageObjectAttributeForMappingType,
      query:this.query,
      dnsType:this.selectedStageObjectDetails.dnsType
    }
    this.lookupMultiList.push(item);
  }
    this.createTransformationQuery();
    console.log(this.lookupMultiList);
     this.selectedStageObjectForMappingType=null;
      this.selectedStageObjectDetails=null;
      this.selectedStageObjectAttributeForMappingType=null;
      this.selectedStageObjectAttributesList=[];
      this.query='';
      this.lookUpIndex=null;
      this.lookupButtonName="Save"
      this.gridApi.api.setGridOption('rowData', this.lookupMultiList)
  }
   onGridReadyLookup(params){
    this.gridApi = params;
    //this.gridColumnApi = params.columnApi;
    //this.gridApi.sizeColumnsToFit();
    params.api.setGridOption('rowData', [])
    this.gridApi.api.setGridOption('rowData', this.lookupMultiList)
  }

  EditLookupIcon(event){
    this.lookupButtonName="Update"
     this.selectedStageObjectAttributesList=[]
    this.selectedStageObjectForMappingType=this.lookupMultiList[event.rowData.index].selectedStageObjectForMappingType
    this.selectedStageObjectAttributeForMappingType=this.lookupMultiList[event.rowData.index].selectedStageObjectAttributeForMappingType
    this.query=this.lookupMultiList[event.rowData.index].query
    this.lookUpIndex=event.rowData.index
    // this.ObjectsData
     const stageObject=this.allObjectsList.filter(item=>item.objectname ==  this.selectedStageObjectForMappingType && item.dnsType == this.lookupMultiList[event.rowData.index].dnsType);
     this.selectedStageObjectDetails=stageObject[0]
           console.log(stageObject);
       if(this.selectedStageObjectDetails.dnsType!="ValueMapping"){
           const attributesJson= stageObject[0].objectattributes ? JSON.stringify(JSON.parse(stageObject[0].objectattributes), null, 2):"";
        const columns=JSON.parse(attributesJson)
        // this.selectedStageObjectAttributesList=columns.datasets[0].columns;
       if(columns.datasets){
          this.selectedStageObjectAttributesList=columns.datasets[0].columns;
        }else{
          this.selectedStageObjectAttributesList=columns;
        }
      }else{
        this.spinner.start();
          this.valueMappingservice.retreiveFieldMapping(this.selectedStageObjectDetails.mappingTypeId).subscribe(response=>{
            if(response.error == true){
               this.spinner.stop();
            }else{
              let getdata:any=response
              let data:any = JSON.parse(getdata.mappedFieldsData)
              console.log(data);
              let headers=JSON.parse(getdata.mappedFields)
              if(headers){
                console.log(headers);
                this.valueMappingHeaders=[]
                this.valueMappingHeaders.push(...headers.SourceColumns)
                this.valueMappingHeaders.push(...headers.TargetColumns)
                // this.headersDataDetails=headers
                console.log(this.valueMappingHeaders);
                 this.selectedStageObjectAttributesList=this.valueMappingHeaders
              }
              // if(getdata.mappedFieldsData != null){
              //   let rowData=JSON.parse(getdata.mappedFieldsData)
              //   console.log(rowData);
              //   this.selectedStageObjectAttributesList=rowData;
              // }
               this.spinner.stop();
            }
          })
      }
  }
  deleteLookUpIcon(e){
     this.lookupMultiList.splice(e.rowData.index, 1);
  for(let i=0;i<this.lookupMultiList.length;i++){
    this.lookupMultiList[i].index=i
  }
  this.gridApi.api.setGridOption('rowData', this.lookupMultiList)
  if(this.lookupMultiList.length == 0){
     this.lookupButtonName="Save"
  }
  this.createTransformationQuery();
  }
 getCodeListMappingDetails(CodeListMappingId){
  this.valueMappingservice.retreiveFieldMapping(CodeListMappingId).subscribe(response=>{
            if(response.error == true){
               this.spinner.stop();
            }else{
              let getdata:any=response
              let data:any = JSON.parse(getdata.mappedFieldsData)
              console.log(data);
              let headers=JSON.parse(getdata.mappedFields)
              let codeListData=[]
              codeListData.push(...headers.SourceColumns)
              codeListData.push(...headers.TargetColumns)
              console.log(headers);
              
              console.log(codeListData);
              const distinctCodelistNames = Array.from(
  new Set(data.map(item => item.CODELIST_NAME))
).map(name => ({ CODELIST_NAME: name }));
              console.log(distinctCodelistNames);
              this.codeListNamesDistinctData=distinctCodelistNames;
              this.codeListNameHeaders=codeListData;
              // if(headers){
              //   console.log(headers);
              //   this.valueMappingHeaders=[]
              //   this.valueMappingHeaders.push(...headers.SourceColumns)
              //   this.valueMappingHeaders.push(...headers.TargetColumns)
              //   // this.headersDataDetails=headers
              //   console.log(this.valueMappingHeaders);
              //    this.selectedStageObjectAttributesList=this.valueMappingHeaders
              // }
               this.spinner.stop();
            }
          })
 }
 searchableCodeListName(){
 if(this.codeListNamesDistinctData.length > 0){
        var columndata = []
      console.log(this.codeListNamesDistinctData)
      let selectedPropertyNameDetails;
      var headers={
        "CODELIST_NAME": "CODELIST_NAME",
      }
       columndata.push(headers)
       selectedPropertyNameDetails="CODELIST_NAME"
      let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
        width: "60%",
        autoFocus: false,
        disableClose: true,
        data: { 
          edata:this.codeListNamesDistinctData,
          page:"single",
          columns:columndata,
          selectedValue:[this.codelistName],
          selectedPropertyName:selectedPropertyNameDetails
        }
      });
       dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result != undefined) {
        if(result.selectedRows.length > 0){
         this.codelistName=result.selectedRows[0].CODELIST_NAME;
        }else{
           this.codelistName=null;
        }
        
      }
      })
    }
}
  async getSourceTargetObjects(): Promise<void> {
  this.spinner.start();

  const totalObjects: any[] = [];

  const sourceObjects = () => new Promise<any>((resolve, reject) => {
    if (this.ObjectsData.length === 0) {
      this.commonService.retrieveObjectGroupObjectsbasedDns(this.SourceId).subscribe({
        next: (response) => {
          if (response.error) {
            this.spinner.stop();
            this.snackbar.open(response.statusMessage, 'OK', { duration: 5000 });
            return reject(response.statusMessage);
          }
          this.ObjectsData = response;
          const mapped = this.ObjectsData.map(obj => ({ ...obj, dnsType: 'Source' }));
          resolve(mapped);
        },
        error: reject
      });
    } else {
      const mapped = this.ObjectsData.map(obj => ({ ...obj, dnsType: 'Source' }));
      resolve(mapped);
    }
  });

  const targetObjects = () => new Promise<any>((resolve, reject) => {
    this.commonService.retrieveNonStageObjectsbasedDns(this.targetdnsid).subscribe({
      next: (res) => {
        if (res.error) {
          this.spinner.stop();
          return reject(res.statusMessage);
        }
        const mapped = res.map(obj => ({ ...obj, dnsType: 'Target' }));
        resolve(mapped);
      },
      error: reject
    });
  });

  const valueMappings = () => new Promise<any>((resolve, reject) => {
    if (this.codeListData.length === 0) {
      const dnsId = this.localStorageSettings.getSettings("dnsName");
      this.valueMappingservice.retreiveMappingTypes(dnsId).subscribe({
        next: (res) => {
          if (res.error) {
            this.spinner.stop();
            this.snackbar.open(res.statusMessage, 'OK', { duration: 5000 });
            return reject(res.statusMessage);
          }
          let valueMap:any=res
          const mapped = valueMap.map(obj => ({
            ...obj,
            objectlabel: obj.mappingTypeName,
            objectname: obj.mappingTypeName,
            status: obj.status,
            dnsType: 'ValueMapping'
          }));
          resolve(mapped);
        },
        error: reject
      });
    } else {
      const mapped = this.codeListData.map(obj => ({
        ...obj,
        objectlabel: obj.mappingTypeName,
        objectname: obj.mappingTypeName,
        status: obj.status,
        dnsType: 'ValueMapping'
      }));
      resolve(mapped);
    }
  });

  try {
    const [source, target, valueMap] = await Promise.all([
      sourceObjects(),
      targetObjects(),
      valueMappings()
    ]);

    totalObjects.push(...source, ...target, ...valueMap);
    this.allObjectsList = totalObjects;
  } catch (err) {
    console.error("Error in getSourceTargetObjects:", err);
  } finally {
    this.spinner.stop();
  }
}

deleteMultipleAttributes(){
  if (confirm("Are you sure you want to delete selected attribute mappings ?")) {
  console.log(this.MappingAttributecheckbox);
  this.spinner.start();
   this.mappingAttributeServices.deleteMultipleMappingAttributes(this.MappingAttributecheckbox).subscribe(response=>{
   this.MappingAttributecheckbox = [];
    this.MappingAttributes = []
    this.onMappedAttributesGridReady(this.mappedAttributesGrid);
    this.ButtonApprove = 'Approve'
    this.isvisible = true;
    this.spinner.stop()
    this.snackbar.open(response.statusMessage, "OK", { duration: 5000 });
   })
  }
}

  importData() {
     
        console.log("<--- Inside upload Group Template --->")
        let width = "85%";
      let dialogRef = this.dialog.open(ImportJsonComponent, {
          maxWidth: "70vw",
          height: "50%",
          width: width,
        data: { "tablename": this.importExportTableName},
          disableClose: true,
        });
      
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
      
          //this.reportCreationData = result;
      
          //this.vaultObjectService.retrieveobjectgroup();
        });
      
      
    }
    
  
    async exportData() {
      this.snackbar.open("Export Process is InProgress. Please do not click again the Export until it completes the Export.", "OK", { duration: 10000 });
      let tenantid = localStorage.getItem("dnsName")
     
  
        try {
          const blob = await this.commonService.downloadJsonFile(this.importExportTableName, tenantid);
          const link = document.createElement('a');
          const timestamp = new Date().getTime();
          link.href = window.URL.createObjectURL(blob);
          link.download = `${this.importExportTableName}_export_${timestamp}.json`;
          link.click();
          window.URL.revokeObjectURL(link.href);
  
        } catch (error) {
          console.error('Error downloading JSON:', error);
        }
      
      
    }
  //  /**
  //  * @Author DARSHAN NAGARAJ
  //  * @Date 05-05-2026
  //  * @Desc Evaluate that only a single source/stage object is selected for mappings other than Functional Mapping.
  //  */
    validateSingleSourceSelection() {
       console.log("Mapping Type:", this.mappingType);
  console.log("Selected Source Attribute List:", this.selectedSourceAttributeList);
    if (!this.mappingType) {
    return true;
  }

  if (this.mappingType !== "Functional Mapping" && this.selectedSourceAttributeList.length > 1) {

    this.snackbar.open(
      "Multiple source attributes are allowed only for Functional Mapping",
      "OK",
      { duration: 5000 }
    );

    //  Clear TS data
    this.selectedSourceAttributeList = [];
    this.selectedSourceAttribute = "";

    //  Clear UI selection
    if (this.sourceGrid && this.sourceGrid.api) {
      this.sourceGrid.api.deselectAll();
    }

    return false; 
  }

  return true;
}

onExpressionChange(value: string): void {
  console.log(value);
  
}
}
  